import React, { useEffect } from 'react';
import './AddIncomePopup.css'

const AddIncomePopup = ({ 
  formData, 
  setFormData, 
  onSave, 
  onCancel, 
  isEditing = false,
  title = 'Add New Income',
  saveButtonText = 'Add Income'
}) => {
  // Prevent background scrolling when popup is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="IncomePopup__popup-overlay">
      <div className="IncomePopup__popup">
        <div className="IncomePopup__popup-header">
          <h3 className="IncomePopup__popup-title">{title}</h3>
          <button
            type="button"
            onClick={onCancel}
            className="IncomePopup__popup-close"
          >
            ×
          </button>
        </div>
        
        <div className="IncomePopup__popup-content">
          <div className="IncomePopup__field-group">
            <label className="IncomePopup__label">Income Name *</label>
            <input 
              name="name"
              placeholder="Enter income source name" 
              className="IncomePopup__input" 
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="IncomePopup__field-group">
            <label className="IncomePopup__label">Description</label>
            <textarea 
              name="description"
              placeholder="Enter description (optional)" 
              className="IncomePopup__textarea" 
              value={formData.description}
              onChange={handleChange}
              rows="3"
            />
          </div>
          
          <div className="IncomePopup__field-group">
            <label className="IncomePopup__label">Amount *</label>
            <input 
              name="total_amount"
              type="number"
              step="0.01"
              min="0"
              placeholder="Enter amount" 
              className="IncomePopup__input" 
              value={formData.total_amount}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="IncomePopup__field-group">
            <label className="IncomePopup__label">Income Date *</label>
            <input 
              name="income_date"
              type="date"
              className="IncomePopup__input" 
              value={formData.income_date}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        
        <div className="IncomePopup__popup-footer">
          <button
            type="button"
            onClick={onCancel}
            className="IncomePopup__button IncomePopup__button--cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSave}
            className="IncomePopup__button IncomePopup__button--save"
            disabled={!formData.name.trim() || !formData.total_amount || !formData.income_date}
          >
            {saveButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddIncomePopup;
